import { DropdownModule } from 'primeng/dropdown';
import { VewMixedComponent } from './charts/mixed/vew-mixed/vew-mixed.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { WidgetsModule } from './widgets/widgets.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { pgCollapseModule } from './collapse/collapse.module';

import { HeaderComponent } from './header/header.component';
import { ViewDirective } from './view/view.directive';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ContainerComponent } from './container/container.component';
import { pageContainer } from './container/page-container.component';
import { SidebarComponent } from './sidebar/sidebar.component';

import { MessageService } from './message/message.service';
import { LockscreenComponent } from './lockscreen/lockscreen.component';
import { TranslateModule } from '@ngx-translate/core';
// import { TranslationShared } from 'src/app/_shared/translation/translation-shared.module';
import { pgTabsModule } from './tabs/tabs.module';
import { ProgressModule } from './progress/progress.module';
import { pgCardModule } from './card/card.module';
import { CheckboxModule} from 'primeng/checkbox';
import { GalleriaModule } from 'primeng/galleria'



import {DialogModule} from 'primeng/dialog';
import {ToolbarModule} from 'primeng/toolbar';
import {SidebarModule} from 'primeng/sidebar';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import { DialogLookupComponent } from './dialog-lookup/dialog-lookup.component';
import {TableModule} from 'primeng/table';
import {FileUploadModule} from 'primeng/fileupload';
import { ColorPickerModule } from "primeng/colorpicker";
import {FileUploadComponent } from './file-upload/file-upload.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { RadarChartComponent } from './charts/radar-chart/radar-chart.component';
import { BarVerticalComponent } from './charts/bar-vertical/bar-vertical.component';
import { BarComponent } from './charts/bar/bar.component';
import { Active_InactivePipe } from 'src/app/_shared/activo_inactivo/activo_inactivo.pipe';
import { PieChartComponent } from './charts/pie-chart/pie-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { VewPieChartComponent } from './charts/pie-chart/vew-pie-chart/vew-pie-chart.component';
import { RadialBarComponent } from './charts/radialbar/radialbar.component';
import { VewRadialBarComponent } from './charts/radialbar/vew-radialbar-chart/vew-radialbar.component';
import { PolarChartComponent } from './charts/polar-chart/polar-chart.component';
import { ViewPolarChartComponent } from './charts/polar-chart/view-polar-chart/view-polar-chart.component';
import { VewRadarComponent } from './charts/radar/vew-radar-chart/vew-radar.component';
import { RadarComponent } from './charts/radar/radar.component';
import { MixedComponent } from './charts/mixed/mixed.component';
import { VewDonutChartComponent } from './charts/donut-chart/vew-donut-chart/vew-donut-chart.component';
import { DonutChartComponent } from './charts/donut-chart/donut-chart.component';
import { lineChartComponent } from './charts/line-chart/line-chart.component';
import { VewlineChartComponent } from './charts/line-chart/vew-line-chart/vew-line-chart.component';
import { areaChartComponent } from './charts/area/area-chart.component';
import { VewAreaChartComponent } from './charts/area/vew-area-chart/vew-area-chart.component';
import { columnChartComponent } from './charts/column/column-chart.component';
import { VewColumnChartComponent } from './charts/column/vew-column-chart/vew-column-chart.component';
import { numberChartComponent } from './charts/number/number-chart.component';
import { VewNumberChartComponent } from './charts/number/vew-number-chart/vew-number-chart.component';




@NgModule({
  imports: [
    TranslateModule,
    FormsModule,
    CommonModule,
    PerfectScrollbarModule,
    RouterModule,
    // TranslationShared,
    pgCollapseModule,
    pgTabsModule,
    ProgressModule,
    pgCardModule,
    CheckboxModule,
    GalleriaModule,
    DropdownModule,
    DialogModule,
    ToolbarModule,
    SidebarModule,
    DynamicDialogModule,
    TableModule,
    FileUploadModule,
    NgxSpinnerModule,
    WidgetsModule,
    ModalModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    ColorPickerModule,
  ],
  declarations: [
    ViewDirective,
    ContainerComponent,
    pageContainer,
    SidebarComponent,
    HeaderComponent,
    LockscreenComponent,
    DialogLookupComponent,
    FileUploadComponent,
    SpinnerComponent,
    RadarChartComponent,
    BarVerticalComponent,
    BarComponent,
    Active_InactivePipe,
    BreadcrumbComponent,
    PieChartComponent,
    VewPieChartComponent,
    RadialBarComponent,
    VewRadialBarComponent,
    PolarChartComponent,
    ViewPolarChartComponent,
    RadarComponent,
    VewRadarComponent,
    MixedComponent,
    VewMixedComponent,
    VewDonutChartComponent,
    DonutChartComponent,
    lineChartComponent,
    VewlineChartComponent,
    areaChartComponent,
    VewAreaChartComponent,
    columnChartComponent,
    VewColumnChartComponent,
    numberChartComponent,
    VewNumberChartComponent,
  ],
  exports: [
    ViewDirective,
    ContainerComponent,
    pageContainer,
    SidebarComponent,
    HeaderComponent,
    pgCollapseModule,
    pgTabsModule,
    ProgressModule,
    pgCardModule,
    GalleriaModule,
    DialogLookupComponent,
    FileUploadComponent,
    SpinnerComponent,
    RadarChartComponent,
    BarVerticalComponent,
    BarComponent,
    Active_InactivePipe,
    BreadcrumbComponent,
    WidgetsModule,
    PieChartComponent,
    VewPieChartComponent,
    RadialBarComponent,
    VewRadialBarComponent,
    PolarChartComponent,
    ViewPolarChartComponent,
    RadarComponent,
    VewRadarComponent,
    MixedComponent,
    VewMixedComponent,
    VewDonutChartComponent,
    DonutChartComponent,
    lineChartComponent,
    VewlineChartComponent,
    areaChartComponent,
    VewAreaChartComponent,
    columnChartComponent,
    VewColumnChartComponent,
    numberChartComponent,
    VewNumberChartComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [MessageService, NgxSpinnerService]
})
export class SharedModule {}